import {Injectable} from '@angular/core'
import {ExpensePaymentStatusAPIModel} from '../../models/api.model'
import {map, Observable} from 'rxjs'
import {ServiceUrlConstants} from 'src/constants/service-url-constants'
import {WebService} from '../api/web.service'
import {AppState} from 'src/store/state/app.state'
import {Store} from '@ngrx/store'
import {getExpensePaymentsHistory} from 'src/store/selector/payment.selector'

@Injectable({
  providedIn: 'root'
})
export class PaymentService {
  constructor(private webService: WebService, private appState: Store<AppState>) {}

  callUpdateExpensePaymentsStatusApi({ id, paymentType, status, statusUpdateInfo }) {
    const url = `${ServiceUrlConstants.API_EXPENSE}/${id}/${paymentType}/status/${status}`
    return this.webService
      .put(url, { ...statusUpdateInfo })
  }

  callFetchExpensePaymentsHistoryApi(id: string, paymentType: string) {
    const url = `${ServiceUrlConstants.API_EXPENSE_PAYMENTS_HISTORY_BY_EXPENSE_ID.replace('{0}', id).replace('{1}', paymentType)}`
    return this.webService.get(url).pipe(map((data: ExpensePaymentStatusAPIModel[]) => data))
  }

  getExpensePaymentsHistoryFromStore = (): Observable<ExpensePaymentStatusAPIModel[]> => {
    return this.appState.select(getExpensePaymentsHistory())
  }

  callUpdateRejectionType(id: string, rejectionType: string) {
    const url = `${ServiceUrlConstants.API_EXPENSE}/payment/${id}/rejectionType/${rejectionType}`
    return this.webService.post(url, {})
  }
}
